import { connect } from "react-redux";
import { compose } from "redux";

import { resizableRoute } from "pages/_components/Resizable";
import { selectors as formSelectors } from "reducers/form";
import { selectors as i18nSelectors } from "reducers/i18n";
import { selectors as statusSelectors } from "reducers/status";

import FormRender from "pages/forms/_components/FormRender";

const mapStateToProps = (state) => ({
    id: formSelectors.getId(state),
    metadata: formSelectors.getMetadata(state),
    fetching: formSelectors.getFetching(state),
    currentLang: i18nSelectors.getLang(state),
    data: formSelectors.getData(state),
    transaction: formSelectors.getTransaction(state),
    childrenTransactions: formSelectors.getChildrenTransactions(state),
    parentTransaction: formSelectors.getParentTransaction(state),
    mode: formSelectors.getMode(state),
    credentialsGroups: formSelectors.getCredentialsGroups(state),
    isCancellingTransaction: formSelectors.getIsCancellingTransaction(state),
    lastHrefPathname: statusSelectors.getPathname(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(FormRender);
